<script setup lang="ts">
  import { ref } from 'vue';
  import { VueFinalModal } from 'vue-final-modal';
  import { IconRadio, ModalActions, ThemeProvider, UiModalHeader } from '@/shared/ui';

  const props = withDefaults(
    defineProps<{
      isExporting?: boolean;
    }>(),
    { isExporting: false }
  );

  const emit = defineEmits<{
    close: [];
    confirm: [includePreviousRevisions: boolean];
  }>();

  const INCLUDE = 'incluir';
  const EXCLUDE = 'nao-incluir';

  const choice = ref<string>(EXCLUDE);

  function handleClose(): void {
    if (props.isExporting) return;
    emit('close');
  }

  function handleConfirm(): void {
    if (props.isExporting) return;
    emit('confirm', choice.value === INCLUDE);
  }
</script>

<template>
  <VueFinalModal
    class="flex justify-center items-center"
    content-class="flex flex-col bg-white-01 rounded-2xl w-full max-w-md shadow-lg"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
    :click-to-close="!props.isExporting"
    :esc-to-close="!props.isExporting"
  >
    <ThemeProvider class="flex flex-col">
      <UiModalHeader
        class="px-6 py-4 text-sm border-b border-gray-02 shrink-0"
        title="Exportar para Excel"
        @close="handleClose"
      />

      <div class="px-6 py-6 flex flex-col gap-4">
        <div class="flex flex-col gap-3">
          <IconRadio
            :value="INCLUDE"
            label="Incluir revisões anteriores"
            name="recordListExportScope"
            :model-value="choice"
            :disabled="props.isExporting"
            data-testid="record-list-export-include"
            @update:model-value="(value: string) => (choice = value)"
          />
          <IconRadio
            :value="EXCLUDE"
            label="Não incluir revisões anteriores"
            name="recordListExportScope"
            :model-value="choice"
            :disabled="props.isExporting"
            data-testid="record-list-export-exclude"
            @update:model-value="(value: string) => (choice = value)"
          />
        </div>

        <p
          class="text-gray-03 text-xs/5"
          data-testid="record-list-export-note"
        >
          Observação: ao incluir as revisões anteriores, é possível que elas não estejam de acordo
          com o filtro aplicado.
        </p>
      </div>

      <div class="px-6 py-6 border-t border-gray-02 shrink-0">
        <ModalActions
          :confirm-loading="props.isExporting"
          @close="handleClose"
          @confirm="handleConfirm"
        />
      </div>
    </ThemeProvider>
  </VueFinalModal>
</template>
